<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="py-3 text-primary-dark">
              <i class="mdi mdi-checkbox-blank-circle" style="position:relative;top:4px;"></i>
              برداشت شما فقط می تواند به صورت تتر باشد. لطفا کیف پول تتر خود را ایجاد نمایید.
            </div>

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  کیف پول های من 
                  <div class="mdi mdi-information-outline"></div>
                </div>
                <div>
                  <add-wallet>
                    <button class="ar-btn size-sm primary">افزودن کیف پول <i class="mdi mdi-plus"></i></button>
                  </add-wallet>
                </div>
              </div>
              <div class="ar-card-body p-0">

                <div class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>نماد</th>
                        <th>آدرس</th>
                        <th>شبکه</th>
                        <th></th>
                      </tr>
                    </thead>
                    <div v-if="!Object.keys(state_wallets).length" class="wallet-placeholder">هنوز کیف پولی ایجاد نشده است .</div>
                    <tbody>
                      <tr v-for="(item , key) in state_wallets" :key="key">
                        <th>{{ key+1 }}</th>
                        <td >
                          <img class="m-auto" :src="StaticImageUrl+'assets/images/icon/'+item.crypto_symbol+'USDT.png'" style="height:30px">
                          <div class="symbol">{{item.crypto_symbol}}</div>
                        </td>
                        <td :title="item.address">
                          {{item.address}}  
                        </td>
                        <td>
                          {{item.network}}  
                        </td>
                        <td>
                          <i @click="delete_wallet_id = item.id , delete_modal = true" class="mdi mdi-trash-can-outline font-2 text-danger"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <modal @close="delete_modal = false" :open="delete_modal" :maxWitdh="'600px'">
              
              <div class="ar-card">
                <div class="ar-card-header">
                  <div class="ar-card-title">
                     حذف ولت
                  </div>
                  <span>
                    <i @click="delete_modal = false" class="mdi mdi-close"></i>
                  </span>
                </div>
                <div class="ar-card-body">
                  از حذف این ولت اطمینان کامل دارید؟
                </div>
                <div class="ar-card-footer">
                  <button @click="deleteWallet()" class="ar-btn size-sm danger">حذف</button>
                  <button @click="delete_modal = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
                </div>
              </div>
              
            </modal>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import AddWallet from '../../components/AddWallet.vue'
import Modal from '../../components/Modal.vue'
export default {
  name: 'BankAccounts',
  components:{
    Sidebar,
    AddWallet,
    HelperNav,
    Modal,
    Header,
  },
  data : () => ({
    delete_wallet_id:null,
    delete_modal:false,
  }),
  methods:{
    deleteWallet (){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`deleteWallet`,{id:this.delete_wallet_id},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.StoreWallets(res.data.data)
        this.delete_modal = false
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
  }
}
</script>